import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import type {
    FavoriteData,
    FavoriteOperationError,
    OutlookFavoriteKind,
} from 'owa-favorites-types';

export interface AddFavoriteCompletedActionMessage {
    temporaryData: FavoriteData;
    favoriteData: FavoriteData;
    newIndex: number | undefined;
}
export const addFavoriteCompleted: (
    temporaryData: FavoriteData,
    favoriteData: FavoriteData,
    newIndex?: number
) => AddFavoriteCompletedActionMessage = action(
    'addFavoriteCompleted',
    (
        temporaryData: FavoriteData,
        favoriteData: FavoriteData,
        newIndex?: number
    ): AddFavoriteCompletedActionMessage =>
        addDatapointConfig(
            'AddFavoriteCompleted',
            favoriteData.mailboxInfo,
            {
                customData: {
                    temporaryFavoriteId: temporaryData.favoriteId,
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                temporaryData,
                favoriteData,
                newIndex,
            }
        )
);

export interface AddFavoriteFailedActionMessage {
    error: FavoriteOperationError;
    favoriteData: FavoriteData;
    favoriteKind: OutlookFavoriteKind;
}
export const addFavoriteFailed: (
    error: FavoriteOperationError,
    favoriteData: FavoriteData
) => AddFavoriteFailedActionMessage = action(
    'addFavoriteFailed',
    (error: FavoriteOperationError, favoriteData: FavoriteData): AddFavoriteFailedActionMessage =>
        addDatapointConfig(
            'AddFavoriteFailed',
            favoriteData.mailboxInfo,
            {
                customData: {
                    errorMessage: error ? error.message : 'Undefined error',
                    cV: error ? error.correlationVector : 'Undefined error',
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                error,
                favoriteData,
                favoriteKind: favoriteData.type,
            }
        )
);

export interface AddFavoriteToStoreActionMessage {
    favoriteData: FavoriteData;
    newIndex: number | undefined;
}
export const addFavoriteToStore: (
    favoriteData: FavoriteData,
    newIndex?: number
) => AddFavoriteToStoreActionMessage = action(
    'addFavoriteToStore',
    (favoriteData: FavoriteData, newIndex?: number): AddFavoriteToStoreActionMessage =>
        addDatapointConfig(
            'AddFavoriteToStore',
            favoriteData.mailboxInfo,
            {
                customData: {
                    favoriteId: favoriteData.favoriteId,
                    favoriteKind: favoriteData.type,
                },
            },
            {
                favoriteData,
                newIndex,
            }
        )
);
